import { PuntoVenta } from "./puntoventa.models";
import { Integration } from "./integration.models";

// Enum para tipos de tienda
export enum StoreType {
  CATALOG = 'catalog',
  ECOMMERCE = 'ecommerce'
}

export interface Store {
  id?: number | null;
  cuit?: string;
  name: string;
  title?: string;
  subtitle?: string;
  bannerUrl?: string;
  faviconUrl?: string;
  available: number;
  type?: StoreType;
  status?: string;
  address?: string;
  email?: string;
  phone?: string;
  timeZone?: string;
  cellphone?: string;
  logo?: string;
  ipAddress?: string;
  domain?: string;
  companyId: number;
  salesPointId?: number;
    
  // Información de la empresa anidada (viene en la respuesta de la API)
  company?: {
    id: number;
    socialReason?: string;
    fantasyName?: string;
    activityStartDate?: string | null;
    logo?: string;
    commercialAddress?: string;
    phone?: string;
    email?: string;
    documentNumber?: string;
    ownerEmail?: string | null;
    timeZone?: string | null;
    grossIncome?: string | null;
    responsibleTypeId?: number;
    createdAt?: string;
    updatedAt?: string;
    deletedAt?: string | null;
  };
  
  // Campos adicionales para compatibilidad con el frontend existente
  puntoventa?: PuntoVenta;
  fechaBaja?: Date;
  fechaCreate?: Date;
  createdAt?: string;
  updatedAt?: string;
  deletedAt?: string | null;
}

// Mantenemos la clase Tienda original para compatibilidad hacia atrás
export class Tienda {
  id: number;
  cuit: string;
  nombre: string;
  disponible: boolean;
  status: string;
  domicilio: string;
  email: string;
  telefono: string;
  zonahoraria: string;
  puntoventa: PuntoVenta;
  celular: string;
  logo: string;
  ip: string;
  dominio: string;
  fechaBaja: Date;
  fechaCreate: Date;
}

// DTO para crear stores - Alineado con el backend
export interface CreateStoreDto {
  cuit?: string;
  name: string;
  title?: string;
  subtitle?: string;
  bannerUrl?: string;
  faviconUrl?: string;
  available?: number;
  type?: StoreType;
  status?: string;
  address?: string;
  email?: string;
  phone?: string;
  timeZone?: string;
  cellphone?: string;
  logo?: string;
  ipAddress?: string;
  domain?: string;
  companyId: number;
  salesPointId?: number;
}

// DTO para actualizar stores
export interface UpdateStoreDto {
  cuit?: string;
  name?: string;
  title?: string;
  subtitle?: string;
  bannerUrl?: string;
  faviconUrl?: string;
  available?: number;
  type?: StoreType;
  status?: string;
  address?: string;
  email?: string;
  phone?: string;
  timeZone?: string;
  cellphone?: string;
  logo?: string;
  ipAddress?: string;
  domain?: string;
  companyId?: number;
  salesPointId?: number;
}

// Helper functions para conversión entre isCatalog y StoreType
export function storeTypeToIsCatalog(type?: StoreType): boolean {
  return type === StoreType.CATALOG;
}

export function isCatalogToStoreType(isCatalog?: boolean | number): StoreType {
  if (typeof isCatalog === 'number') {
    return isCatalog === 1 ? StoreType.CATALOG : StoreType.ECOMMERCE;
  }
  return isCatalog ? StoreType.CATALOG : StoreType.ECOMMERCE;
}
  